import _ = require("underscore");
import $ = require("jquery");
import Mn = require("backbone.marionette");
import template = require("../templates/layerpicker-template");
import Collection = require("../collections/base-collection");
import Model = require("../models/base-model");
import Portal = require("portal-gis");
import Utils = require("../utils");
import Base = require("./base-view");

function isVisible(layer: Portal.MapLayerLeaf) {
    return false !== Utils.extend(layer).visible;
}

function setVisible(layer: Portal.MapLayerLeaf, value = true, recursive = false) {
    if (Utils.extend(layer).visible !== value) {
        Utils.extend(layer).visible = value;
        console.log("layer visibility modified: ", layer.id, value);
    }
    if (recursive) {
        if (layer.Layers) {
            layer.Layers.Layers.forEach(l => setVisible(l, value, true));
        }
    }
}

class LayerView extends Base<Portal.MapLayerLeaf> {

    static about = `
The app/controls/layerpicker-tool uses this view to render layers.
    `;

    execute(options) {

        this.events = <any> {
            "change input": "onChange"
        };

        return super.execute(_.defaults(options, {
            className: "layers-tool-view",
            tagName: "div",
            template: template
        }));
    }

    onBeforeRender() {
        // assign "visible" based on options
        super.onBeforeRender();
        this.collection.forEach(m => this.assignFromOptions(m.data));
    }

    renderItem(item: Portal.MapLayerLeaf) {
        // this is very bad as it does not do cleanup when swapping views!
        // TODO: the inner-layers to become child views?
        let node = Utils.byClass(`layer-${item.id}`, this.$el);
        if (!node.length) return;

        let expando = $(">.expando", node);
        if (!expando.length) return;

        expando.click(el => {
            expando.toggleClass("closed");
            let closed = expando.hasClass("closed");
            Utils.extend(item, { expandoClosed: closed });
        });

        item.Layers && item.Layers.Layers.forEach(l => this.renderItem(l));
    }

    private createItem(model: Model<Portal.MapLayerLeaf>) {
        let node = document.createElement("div");
        this.$el.append(node);
        return node;
    }

    refreshItem(model: Model<Portal.MapLayerLeaf>) {
        console.log("refreshing layer: ", model.data.id);
        let node = this.$(`.layer-${model.data.id}`);
        if (!node.length) node = $(this.createItem(model));
        let html = this.getOption<Function>("template")({ items: [model.data] });
        // this is very bad if it does not do cleanup, use a child view?
        node.replaceWith(html);
        this.renderItem(model.data);
    }

    private getLayers(layers?: Portal.MapLayerLeaf[]) {
        if (!layers) layers = this.mediator.api.layers.map(l => l.data);
        let result = <Portal.MapLayerLeaf[]>[];
        layers.forEach(l => result.push(l));
        layers.filter(layer => !!layer.Layers).forEach(layer => {
            let subLayers = this.getLayers(layer.Layers.Layers);
            subLayers.forEach(l => result.push(l));
        });
        return result;
    }

    private value(layers: Portal.MapLayerLeaf[], result: any) {
        layers.forEach(layer => {
            result[layer.id] = isVisible(layer);
            layer.Layers && this.value(layer.Layers.Layers, result);
        });
    }

    private findLayer(id: string, layers?: Array<Portal.MapLayerLeaf>) {
        let result: Portal.MapLayerLeaf;

        if (layers) {
            result = layers.filter(l => l.id === id)[0];
            if (!result) {
                layers.some(l => {
                    result = l.Layers && this.findLayer(id, l.Layers.Layers);
                    return !!result;
                });
            }
        } else {
            let c = this.collection.get(id);
            result = c && c.data;
            if (!result) {
                this.collection.some(c => {
                    result = c.data.Layers && this.findLayer(id, c.data.Layers.Layers);
                    return !!result;
                });
            }
        }

        return result;
    }

    private assignFromOptions(layer: Portal.MapLayerLeaf) {
        let options = Utils.asDictionary(layer.Options.Values);
        let checked = "false" !== options["visible"];
        if (Utils.extend(layer).visible !== checked) {
            console.log("layer visibility modified: ", layer.id, checked);
            Utils.extend(layer).visible = checked;
        }
        if (layer.Layers) {
            layer.Layers.Layers.forEach(l => this.assignFromOptions(l));
        }
    }

    private assignFromCheckbox(layer: Portal.MapLayerLeaf) {
        let checkbox = this.$(`input[id="${layer.id}"]`);
        let checked = checkbox.prop("checked");
        if (checked === isVisible(layer)) return;

        // toggle layer visibility
        setVisible(layer, checked, !checked);

        // if newly visible and has children, do it again
        if (checked && layer.Layers) {
            layer.Layers.Layers.forEach(l => this.assignFromCheckbox(l));
        }
    }

    private onChange(event: { target: HTMLInputElement }) {
        let layerId = event.target.id;

        let layer = this.findLayer(layerId);
        if (!layer) {
            console.error("could not find layer: ", layerId);
            return;
        }

        // if not checked then hide all children as well
        // if checked, honor checkbox values for all children
        this.assignFromCheckbox(layer);

        let value = {};
        this.value(this.collection.models.map(m => m.data), value);
        this.trigger("visible:changed", {
            value: value,
            layer: layer
        });
    }

}

export = LayerView;